import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login');
  };

  const menuItems = [
    { path: '/admin', icon: '📊', label: 'Dashboard', exact: true },
    { path: '/admin/visitors', icon: '👥', label: 'Visitors' },
    { path: '/admin/banners', icon: '🎠', label: 'Banners' },
    { path: '/admin/blogs', icon: '📝', label: 'Blogs' },
    { path: '/admin/galleries', icon: '🖼️', label: 'Galleries' },
    { path: '/admin/exhibitions', icon: '🎨', label: 'Exhibitions' },
    { path: '/admin/enquiries', icon: '✉️', label: 'Enquiries' },
    { path: '/admin/notifications', icon: '🔔', label: 'Notifications' },
    { path: '/admin/terms', icon: '📋', label: 'Terms & Conditions' },
    { path: '/admin/settings/print-templates', icon: '🖨️', label: 'Print Templates' },
  ];

  const isActive = (path, exact) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-logo">SSVASS Admin</h2>
          <button 
            className="sidebar-toggle" 
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle sidebar"
          >
            {sidebarOpen ? '◀' : '▶'}
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar-nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
            >
              <span className="sidebar-nav-icon">{item.icon}</span>
              {sidebarOpen && <span className="sidebar-nav-label">{item.label}</span>}
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <Link 
            to="/admin/profile" 
            className={`sidebar-nav-item ${isActive('/admin/profile') ? 'active' : ''}`}
          >
            <span className="sidebar-nav-icon">👤</span>
            {sidebarOpen && <span className="sidebar-nav-label">Profile</span>}
          </Link>
          <button className="sidebar-nav-item logout-btn" onClick={handleLogout}>
            <span className="sidebar-nav-icon">🚪</span>
            {sidebarOpen && <span className="sidebar-nav-label">Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="admin-main">
        {/* Top Header */}
        <header className="admin-header">
          <div className="admin-header-left">
            <button 
              className="mobile-sidebar-toggle" 
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              ☰
            </button>
            <h1 className="admin-page-title">
              {menuItems.find(item => isActive(item.path, item.exact))?.label || 'Admin Panel'}
            </h1>
          </div>
          <div className="admin-header-right">
            <button className="header-icon-btn" title="Notifications">
              🔔
            </button>
            <Link to="/admin/profile" className="header-profile">
              <div className="header-profile-avatar">👤</div>
              <span className="header-profile-name">Admin</span>
            </Link>
          </div>
        </header>

        {/* Page Content */}
        <main className="admin-content">
          <Outlet />
        </main>

        {/* Footer */}
        <footer className="admin-footer">
          <p>&copy; {new Date().getFullYear()} SSVASS. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default AdminLayout;
